// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { CatalogFeed } from './catalog-feed';
import { CatalogFeedEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class CatalogFeedRun extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** Enum FK catalogFeed */
  catalogFeedId!: CatalogFeedEnum;
  /** DateTimeOffset */
  completedTs?: Date;
  /** Int32 */
  failureCount!: number;
  /** String(1000) */
  firstFailure?: string;
  /** Binary */
  rowVersion!: any;
  /** Int32 */
  rowsStaged!: number;
  /** String(400) */
  sourceIdentity?: string;
  /** DateTimeOffset */
  sourceModifiedTs?: Date;
  /** String(400) */
  sourceName?: string;
  /** DateTimeOffset */
  startedTs!: Date;
  /** Int32 */
  stylesAttempted!: number;
  /** Int32 */
  stylesSucceeded!: number;
  /** Int32 */
  stylesWithNoImages!: number;
  /** FK catalogFeedId */
  catalogFeed!: CatalogFeed;
}

